import React from "react";

import { CookieConsentProvider } from "frontend/context/CookieConsentContext";
import CookiesBanner from "frontend/components/core/CookiesBanner";

const LegacyCookiesBanner = () => {
    return (
        <CookieConsentProvider>
            <CookiesBanner />
        </CookieConsentProvider>
    );
};

export default LegacyCookiesBanner;
